import { render, staticRenderFns } from "./AmountInput.vue?vue&type=template&id=666d07b0"
import script from "./AmountInput.vue?vue&type=script&lang=ts"
export * from "./AmountInput.vue?vue&type=script&lang=ts"
import style0 from "./AmountInput.vue?vue&type=style&index=0&id=666d07b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports